import { render, staticRenderFns } from "./ZTable.vue?vue&type=template&id=920a3082&scoped=true&"
import script from "./ZTable.vue?vue&type=script&lang=js&"
export * from "./ZTable.vue?vue&type=script&lang=js&"
import style0 from "./ZTable.vue?vue&type=style&index=0&id=920a3082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920a3082",
  null
  
)

export default component.exports